/**
 * Extract the `exp` claim (Unix seconds) from a JWT access token.
 *
 * Used to derive the real token lifetime instead of guessing one — notably
 * in iframe mode, where the host hands us only the raw tokens and we must
 * read the expiry from the token itself rather than assume a fixed window.
 *
 * Returns null when the token is malformed or carries no numeric `exp`.
 */
export function parseJwtExp(accessToken: string | undefined): number | null {
  const parts = accessToken?.split('.');

  if (!parts || parts.length < 2) return null;

  try {
    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    ) as Record<string, unknown>;

    return typeof payload['exp'] === 'number' ? payload['exp'] : null;
  } catch {
    // malformed JWT — no expiry available
    return null;
  }
}
